<template>
  <div>
    <div class="flex font-bold justify-center">
      <img class="h-30 w-30" src="/images/img_8.png" alt="">

    </div>

    <div class="flex font-bold justify-center">No data found >.&lt;</div>
  </div>
</template>

<script>
export default {
  props:[],
    components: {},
    data: function () {
        return {}
    },
    computed: {},
    methods: {
    },
    created() {
    },
    mounted() {
    }
}
</script>

